import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const BookmarkIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177447_14304)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.25 3H6.75C5.92157 3 5.25 3.67157 5.25 4.5V21C5.25014 21.2726 5.39815 21.5236 5.63659 21.6557C5.87503 21.7878 6.16636 21.7801 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.8345 21.7796 18.1255 21.787 18.3636 21.655C18.6018 21.523 18.7497 21.2723 18.75 21V4.5C18.75 3.67157 18.0784 3 17.25 3ZM17.25 4.5V15.1472L12.3966 12.1144C12.1534 11.9624 11.8448 11.9624 11.6016 12.1144L6.75 15.1462V4.5H17.25ZM12.3966 16.6144C12.1534 16.4624 11.8448 16.4624 11.6016 16.6144L6.75 19.6472V16.9153L12 13.6341L17.25 16.9153V19.6472L12.3966 16.6144Z"
          fill="#2E2E2E"
        />
      </g>
      <defs>
        <clipPath id="clip0_177447_14304">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BookmarkIcon;
